import Button from '@risksmart-app/components/src/button';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useStartWizard } from './hooks/useStartWizard';

type WizardButtonProps = {
  basePath: string;
  riskId: string;
  onClick: () => void;
};

export const WizardButton: FC<WizardButtonProps> = ({
  onClick,
  basePath,
  riskId,
}) => {
  const { t } = useTranslation('common', { keyPrefix: 'wizard' });
  const { isWizardInProgress, loading, startWizard } = useStartWizard({
    basePath,
    riskId,
    onStartNew: onClick,
  });

  return (
    <Button
      variant={'primary'}
      loading={loading}
      onClick={startWizard}
      // The label is `${'Continue'|'Start'} ${t('wizardName')}` — and
      // `wizardName` is i18n-driven and per-org taxonomy-overridable, so it is
      // not a stable selector. The testid encodes the STATE rather than being a
      // single constant, because this is one button whose label toggles: an
      // e2e spec asserting the Continue path needs to distinguish the two.
      data-testid={isWizardInProgress ? 'continue-rcsa' : 'start-rcsa'}
    >
      {isWizardInProgress ? t('continueWizardTitle') : t('startWizardTitle')}
    </Button>
  );
};
